export const environment = {
  production: true,
  api_report_domain: 'https://report.checkguard-api.com',
  api_domain: 'https://guardwalk-api.com',
};
